import { useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

/**
 * Shared logout logic used by header, session expiry modal, etc.
 * Performs auth context logout, clears relevant localStorage keys, and attempts
 * docId/iv redirect fallback before landing on root.
 */
export const useLogout = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const performLogout = useCallback(() => {
    logout();
    try {
      const raw = localStorage.getItem('user-data');
      localStorage.removeItem("authToken");
      localStorage.removeItem("isAuthenticated");
      localStorage.removeItem("user-data");
      localStorage.removeItem("field-config-cache");
      localStorage.removeItem("metro-config-cache");
      localStorage.removeItem("lastActivityTs");
      localStorage.removeItem("uploadRequiredSectionFieldNames");
      if (raw) {
        const data = JSON.parse(raw);
        const loginURL = data?.loginURL;
        if (loginURL) {
          globalThis.location.href = loginURL;
          return;
        }
      } 
    } catch {
      // ignore storage access issues
    }
    navigate("/");
  }, [logout, navigate]);

  return performLogout;
};

export default useLogout;